"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _gift = require("../Shapes/gift.shape");

var _GiftsHistoryListItem = _interopRequireDefault(require("./GiftsHistoryListItem"));

var _EmptyGiftsHistory = _interopRequireDefault(require("./EmptyGiftsHistory"));

var _UnsubscribedErrorMessage = _interopRequireDefault(require("./UnsubscribedErrorMessage"));

var GiftsHistoryList = function GiftsHistoryList(_ref) {
  var gifts = _ref.gifts,
      userName = _ref.userName,
      userEmail = _ref.userEmail,
      handleGiftCreate = _ref.handleGiftCreate,
      canUseGiftCreateFlow = _ref.canUseGiftCreateFlow,
      onViewGiftDetails = _ref.onViewGiftDetails;
  var isEmpty = gifts.length === 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isEmpty ? /*#__PURE__*/_react.default.createElement(_EmptyGiftsHistory.default, {
    userName: userName,
    handleGiftCreate: handleGiftCreate
  }) : /*#__PURE__*/_react.default.createElement(_material.Grid, null, !canUseGiftCreateFlow && /*#__PURE__*/_react.default.createElement(_UnsubscribedErrorMessage.default, null), gifts.map(function (gift, index) {
    return /*#__PURE__*/_react.default.createElement(_GiftsHistoryListItem.default, {
      hideStatuses: index > 0,
      key: gift.id,
      gift: gift,
      name: userName,
      email: userEmail,
      canUseGiftCreateFlow: canUseGiftCreateFlow,
      onViewGiftDetails: onViewGiftDetails
    });
  })));
};

GiftsHistoryList.propTypes = {
  userName: _propTypes.default.string.isRequired,
  userEmail: _propTypes.default.string.isRequired,
  gifts: _propTypes.default.arrayOf(_gift.giftShape).isRequired,
  canUseGiftCreateFlow: _propTypes.default.bool,
  handleGiftCreate: _propTypes.default.func,
  onViewGiftDetails: _propTypes.default.func
};
GiftsHistoryList.defaultProps = {
  canUseGiftCreateFlow: false,
  handleGiftCreate: function handleGiftCreate() {},
  onViewGiftDetails: function onViewGiftDetails() {}
};
var _default = GiftsHistoryList;
exports.default = _default;